module.exports = __webpack_public_path__ + "img/promotion.075d009b.svg";